<template>
  <div class="TelephoneForm border m-2 p-2">
    <h3>{{ $t('participation.telephoneVerify.header') }}</h3>

    <div v-if="codeCreateError" class="alert alert-error">
      {{ $t('participation.telephoneVerify.send_code_error', { error: codeCreateError }) }}
    </div>

    <div v-if="loaded && !codeCreateError">
      <div v-if="dialogMode == 'VERIFIED-TELEPHONE-MISSING'" class="alert alert-notice">
        {{ $t('participation.telephoneVerify.please_confirm_tel') }}
      </div>
      <div v-if="dialogMode == 'MOBILE-TELEPHONE-MISSING'" class="alert alert-error">
        {{ $t('participation.telephoneVerify.please_correct_tel') }}
      </div>
      <div v-if="hasNonMobile" class="alert alert-notice">
        {{ $t('participation.telephoneVerify.warn_nonmobile', {tel : telephones[1].tnumber} ) }}
      </div>

      <TelephoneInput :showErrors="true" :isRequired="true" :value="telephones[0].tnumber" :countryPrefix="telephones[0].prefix" v-on:upd:telephone="triggerUpd($event)" />

      <div id="submitOrBusy">
        <button v-if="!allValid" class="form-submit" disabled>
          {{ $t('form.generic.btn_form_invalid') }}
        </button>
        <button v-else-if="dialogMode == 'MOBILE-TELEPHONE-MISSING'"
          v-on:click.prevent="verifyTelephone()"
          class="form-submit btn-primary">{{ $t('participation.telephoneVerify.btn_fix_tel') }}
        </button>
        <button v-else-if="dialogMode == 'VERIFIED-TELEPHONE-MISSING'"
          v-on:click.prevent="verifyTelephone()"
          class="form-submit btn-primary">{{ $t('participation.telephoneVerify.btn_request_code') }}
        </button>
      </div>

    </div>
  </div>
</template>

<script>

import {
  getTelephones,
  updateTelephones
} from "@/api/telephone.js";
import TelephoneInput from "@/snippets/TelephoneInput.vue";
import { mapGetters } from "vuex";
import { startTelVerify } from "@/api/participate.js";


export default {
  name: 'TelephoneVerifyForm',
  components: {TelephoneInput},
  props: ["dialogMode", "hasNonMobile"],
  data() {
    return {
      telephones: [],
      loaded: false,
      hasData: false,
      codeCreateError: undefined
    };
  },
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy",
    }),
    allValid: function () {
      if ( this.telephones[0] && this.telValid(this.telephones[0])) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.fetchData()
  },
  async beforeDestroy() {
    await this.trySave();
  },
  methods: {
    triggerUpd(val) {
      this.telephones[0].tnumber = val;
    },
    async fetchData() {
      const rv = await getTelephones(this.$userClient);
      if (rv) {
        if (rv.telephones[0]) {
          this.telephones = rv.telephones;
          if (this.hasNonMobile) {
            this.telephones.unshift({tnumber:""});
          }
        }
        else {
          this.telephones = [{tnumber:""}]
        }
        this.loaded = true;
        this.hasData = this.allValid;
      }
    },
    async trySave() {
      if (this.autoSave && this.allValid) {
        await this.updTelephones();
      }
    },
    async updTelephones() {
      const rv = await updateTelephones(this.$userClient, this.telephones);
      if (rv) {
        this.telephones = rv.telephones;
        this.$emit('mobile-upd', {status:"telephone-update"});
      }
    },
    async verifyTelephone() {
      try {
        await updateTelephones(this.$userClient, this.telephones);
        const rv = await startTelVerify(this.$userClient);
        if (rv && rv.status == 'OK') {
          this.$emit('mobile-code-sent', rv)
        }
      } catch (error) {
        this.codeCreateError = error;
      }
    },
    telValid(tel) {
      return (tel && tel.tnumber && tel.tnumber.length > 5 && tel.tnumber.length <= 20) ? true : false
    }
  }
}
</script>
